import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { TenantDataFileFolderResponse } from '../_objects/tenant-data';

import { HttpService } from './http.service';
import { ElectronService } from '../electron.service';

@Injectable()
export class TenantDataService extends HttpService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router,
    ) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  // --00 PUT /api/tenantdata/contents/delete
  deleteFileFolder(selectedTenantData: TenantDataFileFolderResponse[]): Observable<any> {
    const endpoint = super.getEndpoint('tenantdata', 'contents', 'delete');

      return this.http.put(endpoint, { fileFolder: selectedTenantData },
        { withCredentials: super.getWithCredentialsOption() })
        .pipe(map(response => response));
  }

}
